import { useState, useEffect } from "react";
import "./DreamdorBanner.css";
import { Link } from "react-router-dom";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { baseUrl, counselorId } from "../helper/urls";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const phrases = [
  "Not sure where to start?",
  "Need help with your college list?",
  "Struggling with your essay?",
  "Get expert guidance in just 30 mins!",
];

const DreamdorBanner = () => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [showText, setShowText] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowText(false);
      setTimeout(() => {
        setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        setShowText(true);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const [openReq, setOpenReq] = useState(false);
  const handleOpenReqModal = () => setOpenReq(true);
  const handleCloseReqModal = () => setOpenReq(false);

  const [timeValue, setTimeValue] = useState(null);
  const [errors, setErrors] = useState({ time: false, slots: false });
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false); // fix camelCase

  const createBookingRequest = async () => {
    setLoading(true);
    const startHourStr = timeValue?.split("-")[0];
    const localTime = new Date();

    if (startHourStr) {
      const hourMatch = startHourStr.match(/(\d+)(AM|PM)/);
      if (hourMatch) {
        let hour = parseInt(hourMatch[1]);
        const period = hourMatch[2];

        if (period === "PM" && hour !== 12) hour += 12;
        if (period === "AM" && hour === 12) hour = 0;

        localTime.setHours(hour, 0, 0, 0);
      }
    }
    const utcTime = localTime.toISOString();

    try {
      const response = await axios.post(
        `${baseUrl}/api/booking_req/create`,
        {
          counselorId: counselorId,
          call_time: timeValue,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          utcTime: utcTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response);
      if (response.data.success === true) {
        setOpenReq(false);
        handleApiSuccess(response);
      }
    } catch (error) {
      console.error(
        "Booking request failed:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message || "Failed to create booking request"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleApiSuccess = (response) => {
    Swal.fire({
      // text: response?.data?.message || "Role updated successfully",
      text: "Request created successfully",

      icon: "success",
      timer: 4000,
      showConfirmButton: true, // optional: allow manual dismissal
      allowOutsideClick: true,
      allowEscapeKey: true,
    }).finally(() => {
      setTimeValue(null);
      // navigate("/student-requested-slot-list");
    });
  };

  const handleSubmit = () => {
    const newErrors = {
      time: !timeValue,
      // slots: !slotsValue,
    };
    setErrors(newErrors);
    // if (!newErrors.time && !newErrors.slots) {
    if (!newErrors.time) {
      createBookingRequest();
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="">
        {/* <span>🎓 </span>
        <span id="dynamicText" className={showText ? "show" : "hide"}>
          {phrases[currentPhraseIndex]}
        </span>
        {/* <Link
        to="https://wa.me/12062096405?text=Hi"
        target="_blank"
        className="banner-button"
      >
        Book Free 30-Min Session
      </Link> */}
        {/* <button className="banner-button" onClick={handleOpenReqModal}>
          Request Now!
        </button>  */}

        {/* <a href="" onClick={handleOpenReqModal} class="request-btn">
          🤝 Request a Counselor Now
        </a> */}
        <button onClick={handleOpenReqModal} class="request-btn">
          🤝 Request a Counselor Now
        </button>

        <Modal
          open={openReq}
          onClose={handleCloseReqModal}
          aria-labelledby="modal-title"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography sx={{ mb: 1 }}>Select Time</Typography>
            <Autocomplete
              options={["9AM-12PM", "12PM-3PM", "3PM-6PM", "6PM-9PM"]}
              value={timeValue}
              onChange={(event, newValue) => setTimeValue(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Best time to call"
                  variant="outlined"
                  error={errors.time}
                  helperText={errors.time ? "This field is required" : ""}
                />
              )}
              sx={{ width: "100%" }}
            />
            <Button
              disabled={loading}
              variant="contained"
              sx={{
                mt: 3,
                width: "100%",
                backgroundColor: "#124178",
                color: "white",
              }}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress /> : "Submit"}
            </Button>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default DreamdorBanner;
